module.exports = __webpack_public_path__ + "static/media/proxxmu-interviewsum.6ad58967.png";